import {UI, registerStyle, styleRule, StyleSheet} from "../../../../../../../stem-core/src/ui/UI";

import {Messages} from "../../../../../../Messages";
import {ConfirmationModal} from "../../../../../../ui/ConfirmationModal";
import {wrapInSpinner} from "../../../../../../../core/ui/LoadingSpinner.jsx";
import {PopupMenu} from "../../../../../../ui/PopupMenu.jsx";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";
import {DonationStore} from "../../../../../../../client/state/DonationStore";
import {apiDeletePaymentMethod, apiSetPrimaryPaymentMethod} from "../../../../../../../client/state/PaymentMethodStore";
import {Toast} from "../../../../../../ui/Toast";
import {unwrapArray} from "../../../../../../../stem-core/src/base/Utils.js";
import {PaymentMethodDescription} from "../../../../../../common/PaymentMethodDescription.jsx";

class RemoveCardModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            testId: "removeCardModal",
            title: Messages.removeCard,
            confirmLabel: Messages.remove,
            confirmAction: () => this.removeCard(),
            description: Messages.removeCardEndingIn(this.options.card.getBrand(), this.options.card.getLastDigits()),
        };
    }

    @wrapInSpinner
    async removeCard() {
        await apiDeletePaymentMethod(this.options.card.id);
        Toast.show(Messages.cardRemoved);
    }
}


class PaymentMethodInlineMenuStyle extends StyleSheet {
    @styleRule
    container = {
        position: "relative",
        padding: "10px 0",
        fontSize: 15,
        display: "flex",
        alignItems: "center",
        color: this.themeProps.MERCHANT_4,
    };

    @styleRule
    cardDetails = {
        marginRight: 6,
    };
}


@registerStyle(PaymentMethodInlineMenuStyle)
export class PaymentMethodInlineMenu extends UI.Element {
    getDefaultOptions() {
        return {
            paymentMethod: null,
            onRemoveAction: (paymentMethod) => RemoveCardModal.show({paymentMethod}),
        };
    }

    removeAction() {
        const {paymentMethod, onRemoveAction} = this.options;
        const entries = [
            ...DonationStore.getActiveRecurring().filter(donation => !donation.isCanceled()),
            ...SubscriptionStore.getActiveAndNotCanceled()
        ].filter(recurringPayment => recurringPayment.getPaymentMethod() === paymentMethod);

        if (entries.length) {
            // If there's an active recurring payment using this
            Toast.showError(Messages.paymentMethodInUseError);
        } else {
            onRemoveAction(paymentMethod);
        }
    }

    async makeDefault() {
        const {paymentMethod} = this.options;
        await apiSetPrimaryPaymentMethod(paymentMethod.id);
        Toast.show(Messages.changesSaved);
    }

    getMenuItems() {
        const {paymentMethod} = this.options;

        return unwrapArray([{
                content: Messages.removeCard,
                onClick: () => this.removeAction(),
            },
            !paymentMethod.isPrimary && {
                content: Messages.makeDefault,
                onClick: () => this.makeDefault(),
            }]);
    }

    render() {
        const {paymentMethod} = this.options;

        return [
            <PaymentMethodDescription
                paymentMethod={paymentMethod}
                showIfDefault
                showExpiryDate
            />,
            <PopupMenu items={this.getMenuItems()}/>
        ];
    }
}
